import { all, takeLatest, put, fork, call } from 'redux-saga/effects';
import actions from './actions';
import * as readAloudServices from '@iso/services/speaking/readAloud';

//#region CRUD
export function* getReadAloud() {
	yield takeLatest(actions.GET_READ_ALOUD, function* ({ payload }) {
		const { model } = payload;
		try {
			var response = yield call(readAloudServices.getReadAloud, model);
			if (response.data.success === true) {
				var data = response.data.data.data;
				var totalItems = response.data.data.total;
				yield put({
					type: actions.GET_READ_ALOUD_SUCCESS,
					payload: { data, totalItems },
				});
			}
		} catch (e) {
			yield put({
				type: actions.SPEAKING_LOADING_FALSE,
			});
		}
	});
}

export function* getReadAloudDetail() {
	yield takeLatest(actions.GET_READ_ALOUD_DETAIL, function* ({ payload }) {
		const { id } = payload;
		try {
			var response = yield call(readAloudServices.getReadAloudDetail, id);
			if (response.data.success === true) {
				var data = response.data.data;
				yield put({
					type: actions.GET_READ_ALOUD_DETAIL_SUCCESS,
					payload: { data },
				});
			}
		} catch (e) {
			yield put({
				type: actions.SPEAKING_LOADING_FALSE,
			});
		}
	});
}

export function* createQuesReadAloud() {
	yield takeLatest(actions.CREATE_NEW_QUESTION_READ_ALOUD, function* ({ payload, cbSuccess, cbError }) {
		const { body } = payload;
		try {
			var response = yield call(readAloudServices.createQuesReadAloud, body);
			if (response.data.success === true) {
				yield cbSuccess();
			}
		} catch (e) {
			if (e?.response?.data?.ErrorMessage && e?.response?.data?.ErrorMessage === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			} else {
				yield cbError(e.response.data.ErrorMessage);
			}
		}
	});
}

export function* updateReadAloudDetail() {
	yield takeLatest(actions.UPDATE_READ_ALOUD_DETAIL, function* ({ payload, cbSuccess, cbError }) {
		const { model } = payload;
		try {
			var response = yield call(readAloudServices.updateReadAloudDetail, model);
			if (response.data.success === true) {
				yield cbSuccess();
			} else if (response?.data?.message === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			}
		} catch (e) {
				if (e?.response?.data?.ErrorMessage && e?.response?.data?.ErrorMessage === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			} else {
				yield cbError(e.response.data.ErrorMessage);
			};
		}
	});
}

export function* deleteReadAloud() {
	yield takeLatest(actions.DELETE_READ_ALOUD, function* ({ payload, cbSuccess, cbError }) {
		const { id } = payload;
		try {
			var response = yield call(readAloudServices.deleteReadAloud, id);
			if (response.data.success === true) {
				yield cbSuccess();
			}
		} catch (e) {
			if (e.response && e.response.data) yield cbError(e.response.data.ErrorMessage);
			else yield cbError();
		}
	});
}

export default function* rootSaga() {
	yield all([fork(getReadAloud), fork(getReadAloudDetail), fork(createQuesReadAloud), fork(updateReadAloudDetail), fork(deleteReadAloud)]);
}
